/**
 * Abre uma URL externa numa nova aba de forma robusta mesmo com o app embarcado
 * no portal xvia.
 *
 * Por que não confiar só em `<a target="_blank">`: embutido no portal, o clique
 * no link externo era coagido para a origem do portal e abria uma página em
 * branco (ex.: dev.pe.gov.br/...) em vez do site externo. Disparar
 * `window.open` explicitamente no onClick escapa dessa coerção. `noopener` (e o
 * reset de `opener`) evita que a nova aba acesse `window.opener`.
 *
 * Mantemos o `href`/`target`/`rel` no anchor por acessibilidade e para o
 * clique do meio (abrir em nova aba) continuar funcionando.
 */
export function openExternal(url) {
    var win = window.open(url, "_blank", "noopener,noreferrer");
    if (win) {
        win.opener = null;
    }
}
